import React from 'react';
import { Music, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();
  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hem" className="min-h-screen flex items-center justify-center bg-white pt-20">
      <div className="max-w-7xl mx-auto px-6 py-20 text-center">
        <div className="space-y-12">
          {/* Large Logo */}
          <div className="flex justify-center animate-fade-in">
            <img
              src="https://customer-assets.emergentagent.com/job_da9e6102-b17b-4e3a-82a5-102f912074e7/artifacts/esnq4twv_S2R_logo_750x750.png"
              alt="Songs To Represent Logo"
              className="w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 object-contain"
            />
          </div>

          {/* Headline */}
          <div className="space-y-6 animate-slide-up">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-black leading-tight">
              {t('hero.title')}
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              {t('hero.subtitle')}
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-delay">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-black text-white hover:bg-gray-800 transition-all duration-300 px-8 py-6 text-lg font-semibold"
            >
              {t('hero.orderButton')}
            </Button>
            <Button
              onClick={() => {
                const element = document.getElementById('om-oss');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              size="lg"
              variant="outline"
              className="border-2 border-black text-black hover:bg-black hover:text-white transition-all duration-300 px-8 py-6 text-lg font-semibold"
            >
              {t('hero.learnMore')}
            </Button>
          </div>

          {/* Feature Icons */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20 max-w-4xl mx-auto">
            <div className="flex flex-col items-center space-y-3 p-6 rounded-lg hover:bg-gray-50 transition-colors duration-200">
              <div className="p-4 bg-black rounded-full">
                <Music className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-black">{t('hero.feature1Title')}</h3>
              <p className="text-gray-600 text-center">{t('hero.feature1Desc')}</p>
            </div>
            <div className="flex flex-col items-center space-y-3 p-6 rounded-lg hover:bg-gray-50 transition-colors duration-200">
              <div className="p-4 bg-black rounded-full">
                <Sparkles className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-black">{t('hero.feature2Title')}</h3>
              <p className="text-gray-600 text-center">{t('hero.feature2Desc')}</p>
            </div>
            <div className="flex flex-col items-center space-y-3 p-6 rounded-lg hover:bg-gray-50 transition-colors duration-200">
              <div className="p-4 bg-black rounded-full">
                <Music className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-black">{t('hero.feature3Title')}</h3>
              <p className="text-gray-600 text-center">{t('hero.feature3Desc')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;